/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type BookingApiResourceVisibleStatus = typeof BookingApiResourceVisibleStatus[keyof typeof BookingApiResourceVisibleStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BookingApiResourceVisibleStatus = {
  Booked: 'Booked',
  Canceled: 'Canceled',
  Checked_In: 'Checked In',
  Checked_Out: 'Checked Out',
  Upcoming: 'Upcoming',
  Tentative: 'Tentative',
  Unavailable: 'Unavailable',
  Others: 'Others',
  ConfirmationPending: 'ConfirmationPending',
} as const;
